/*
 IMPORTANT:
 This file is used only in the vue3 application.
 Any changes made here should also be done in the vue2 file.
 For any clarifications, contact Sai Krishna.

 Vue2File: wwwroot\js\components\rotaionalspecialbanner\RotationalSpecialsContainer\RotationalSpecialsContainer.js
*/

import { defineAsyncComponent } from 'vue';
import { LayoutConstants } from '@/js/constants/LayoutConstants.js';
import { isLincolnDealer } from '../../../Events/FordDirect/FordCookieService';

const PrimaryRotationalSpecials = defineAsyncComponent(() =>
  import('./primaryrotationalspecialbanner.vue')
);
const FrameRotationalSpecials = defineAsyncComponent(() =>
  import('../../RotaionalSpecialBanner/FrameRotationalSpecialBanners.vue')
);
const LuxuryRotationalSpecials = defineAsyncComponent(() =>
  import('../../RotaionalSpecialBanner/luxuryrotationalspecialbanner.vue')
);
const BmwRotationalSpecials = defineAsyncComponent(() =>
  import('../../RotaionalSpecialBanner/bmwrotationalspecialbanner.vue')
);
const MitsubishiOemRotationalSpecialBanners = defineAsyncComponent(() =>
  import('../../RotaionalSpecialBanner/MitsubishiOemRotationalSpecialBanners.vue')
);
const paragonPrimaryRotationalSpecial = defineAsyncComponent(() =>
  import('../../RotaionalSpecialBanner/paragonPrimaryRotationalSpecial.vue')
);
// Async register components locally for Vue 3
export default {
  components: {
    'primary-rotational-specials': PrimaryRotationalSpecials,
    'frame-rotational-specials': FrameRotationalSpecials,
    'luxury-rotational-specials': LuxuryRotationalSpecials,
    'bmw-rotational-specials': BmwRotationalSpecials,
    'mitsubishi-oemRotational-special-banners':MitsubishiOemRotationalSpecialBanners,
    'paragon-primary-rotational-special': paragonPrimaryRotationalSpecial,
  },

  props: {
    designtype: {
      default: '',
      required: false,
    },
  },

  data() {
    return {
      componentName: '',
      isLincoln: isLincolnDealer(window.themeName),
      noVehicleAvailable:
        window.isFdDealer && !(window.CurrentVehicle && window.CurrentVehicle.length > 4),
    };
  },

  methods: {},

  mounted() {
    if (this.designtype && this.designtype !== '0') {
      switch (this.designtype) {
        case '1':
          this.componentName = 'frame-rotational-specials';
          break;
        case '2':
          this.componentName = 'luxury-rotational-specials';
          break;
        case '3':
          this.componentName = 'bmw-rotational-specials';
          break;
        case '4':
          this.componentName = 'paragon-primary-rotational-special';
          break;
        case '5':
          this.componentName = 'primary-rotational-specials';
          break;
        case '6':
          this.componentName = 'mitsubishi-oemRotational-special-banners';
          break;
        default:
          this.componentName = 'primary-rotational-specials';
          break;
      }
      return;
    }

    switch (window.masterLayoutName.toLowerCase()) {
      case LayoutConstants.WEBSITE_FRAME:
        this.componentName = 'frame-rotational-specials';
        break;
      case LayoutConstants.WEBSITE_LUXURY:
        this.componentName = 'luxury-rotational-specials';
        break;
      case LayoutConstants.WEBSITE_LUXURY_PORSCHE:
        this.componentName = 'luxury-rotational-specials';
        break;
      case LayoutConstants.WEBSITE_BMW:
        this.componentName = 'bmw-rotational-specials';
        break;
      case LayoutConstants.WEBSITE_PARAGON_PRIMARY:
        this.componentName = 'paragon-primary-rotational-special';
        break;
      case LayoutConstants.WEBSITE_LIGHTYEAR:
        this.componentName = 'paragon-primary-rotational-special';
        break;
      default:
        this.componentName = 'primary-rotational-specials';
        break;
    }
  },
};
